const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeak(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 480,
    viewBox: "0 0 443 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "kljun2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M159.3,218.2c-6.7-.6-26.4,25.1-25.5,34.6.3,3.3,7.3,4.2,11.9,8.8,6.7,6.7,12.1,16.6,15.3,15.6,5.7-1.8,4.4-31.1,8.8-38.4C161.7,237.1,159.4,220.7,159.3,218.2Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.6,257.8c-13.2-3-13.7,22.9-12,13.9-2.5-2.6,3.2,5.4,5.8,8.1,2.1,2.3,12.5-2.9,12.9-5.8C170.4,271,168.8,258.1,165.6,257.8Z",
    style: {
      fill: "#fecada",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.4,260a8.8,8.8,0,0,0-4.4-.8c-8.4-1.4-14,14-9.6,16.2.2,2.6,9,2.1,10.6,0C168.3,272.3,173.2,261.4,171.4,260Z",
    style: {
      fill: "#ff7d7d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.8,236.5c-1.5,1.9-5.1,8.7-1.7,16,3.6,7.8,7.4,24.5-4.1,23.4-9.8-.9-5.8-20.9-24.6-26.9-.8-.3-3.1,7.7-1.9,7.9a26.15,26.15,0,0,1,18,18.3c.7,2.8,4.2,7.8,7.5,7.8,3.6,0,12.9,1,14.6-13.4,1.5-11.9-5.3-16.2.3-28.1C173.8,243.2,165.9,237.1,165.8,236.5Z",
    style: {
      fill: "#ffb100",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3859000205993652px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.1,204.2c1.2.9,3,2.5,4.4,2.9",
    style: {
      fill: "#fff400",
      stroke: "#fff400",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "0.061089999973773956px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,217.5c4.1,21.9-18.4,22.1-24,35-6.5,9.5,2.5,48-26.2,30.3-5.7-3.8-13.2-8.7-17.7-13.9-22.7-21.1-25.1-61.4,10.3-80.5,18.2-9.1,42.3,8,46.4,12.1C156.6,208.4,159,212.4,160,217.5Z",
    style: {
      fill: "#fff400",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3859000205993652px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7,189c9.1-3.2,24.5,2.8,22.4,4.8-11.7,11.1-29.3,13-33.3,34.3-4.4,23.9,21.3,56.5,25.1,54.6C106.8,287.4,40.8,226.1,107.7,189Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5,191.7c7.1-1.8-22.6,14.7-26.5,36-4.4,23.9,21.9,52.2,35.2,54.4C106,286.9,45.6,228.8,112.5,191.7Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,212.8a21.07,21.07,0,0,0,19,30.9",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "1.6970000267028809px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.64,195c1.84-3.82,12.73,4,11.74,7.07-.14.57-4.24,3.82-6.08,1C129.31,195.39,124.22,195.39,124.64,195Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.14,
    cy: 202.18,
    rx: 3.25,
    ry: 2.55,
    style: {
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "4.526982637095358px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeak);
export default __webpack_public_path__ + "static/media/beak.acce724c59f9e0debebacc96d39ecbea.svg";
export { ForwardRef as ReactComponent };